<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <ion-header class="transparent">
            <app-header class="light-mode"
                        [colorStyle]="'light-mode'"
                        [middleIcon]="true"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="false" [@enter]>
            </app-header>
        </ion-header>

        <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]>
        </div>
        <div class="box" [@enter] *ngIf="userInfo !== null">
            <div class="title">
                {{'__HOME_HI__' | translate}} {{userInfo.first_name}}
                <div *ngIf="userType !== 'coach'" class="desktop-only welcome-text">{{'__HOME_WELCOME_TO_MY721__' | translate}}</div>
                <div *ngIf="userType === 'coach'" class="desktop-only welcome-text">{{'__HOME_COACH_WELCOME_TO_MY721__' | translate}}</div>
            </div>
            <div *ngIf="userType !== 'coach'" class="mobile-only">{{'__HOME_WELCOME_TO_MY721__' | translate}}</div>
            <div *ngIf="userType === 'coach'" class="mobile-only">{{'__HOME_COACH_WELCOME_TO_MY721__' | translate}}</div>
            <div *ngIf="userType !== 'coach'" class="text">{{'__HOME_WELCOME_INTRO_TEXT__' | translate}}</div>
            <div *ngIf="userType === 'coach'" class="text">{{'__HOME_COACH_WELCOME_INTRO_TEXT__' | translate}}</div>
        </div>
        <div class="box" *ngIf="userInfo === null"></div>

        <div class="content-grid">
            <div class="shadow-container grid-middle" *ngIf="userInfo !== null && !!userInfo.dashboard && userInfo.dashboard.sections.length > 0">
                <ng-container *ngFor="let section of this.userInfo.dashboard.sections; let i = index;">
                    <button (click)="buttonClicked(section)"
                            class="shadow-element color-{{section.icon}} custom-section-{{section.uid}}"
                            [ngStyle]="{'background-color' : section.background_color}"
                            *ngIf="section.template !== null || section.sections.length > 0"
                            [ngClass]="{disabled: section.sections.length == 0 && (!section.template || !section.template.stages.active.length)}">
                        <div class="left">
                            <app-inline-icon-svg [section]="section"></app-inline-icon-svg>
                            <div class="description">
                                <div class="big" [ngStyle]="{'color': section.text_primary_color}" [innerHTML]="section.title"></div>
                                <div class="small"
                                     [ngStyle]="{'color': section.text_secondary_color}"
                                     *ngIf="!!section.subtitle" [innerHTML]="section.subtitle"></div>
                            </div>
                            <img *ngIf="false && i < 2" src="assets/icon/sign.svg" style="padding: 0 1rem">
                            <img *ngIf="false && i >= 2" src="assets/icon/sign-placeholder.svg" style="padding: 0 1rem">
                        </div>
                        <ng-container *ngIf="section.sections.length > 0">
                            <svg *ngIf="isOpened && toggleSectionId === section.id" class="arrow-horizontal" xmlns="http://www.w3.org/2000/svg" width="45.571" height="24.081" viewBox="0 0 45.571 24.081">
                                <g transform="translate(45.571) rotate(90)">
                                    <path d="M199.121,252.775l20.58-20.58a1.29,1.29,0,1,0-1.824-1.824l-21.5,21.5a1.285,1.285,0,0,0,0,1.824l21.5,21.488a1.3,1.3,0,0,0,.907.382,1.259,1.259,0,0,0,.907-.382,1.285,1.285,0,0,0,0-1.824Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+section.icon_primary_color"/>
                                </g>
                            </svg>
                            <svg *ngIf="!(isOpened && toggleSectionId === section.id)" class="arrow-horizontal" xmlns="http://www.w3.org/2000/svg" width="45.571" height="24.081" viewBox="0 0 45.571 24.081">
                                <g transform="translate(0 24.081) rotate(-90)">
                                    <path d="M199.121,252.775l20.58-20.58a1.29,1.29,0,1,0-1.824-1.824l-21.5,21.5a1.285,1.285,0,0,0,0,1.824l21.5,21.488a1.3,1.3,0,0,0,.907.382,1.259,1.259,0,0,0,.907-.382,1.285,1.285,0,0,0,0-1.824Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+section.icon_primary_color"/>
                                </g>
                            </svg>

                        </ng-container>
                        <svg *ngIf="section.sections.length === 0" class="arrow" xmlns="http://www.w3.org/2000/svg" width="32.007" height="60.571" viewBox="0 0 32.007 60.571">
                            <g transform="translate(228.008 290.562) rotate(180)">
                                <g transform="translate(196.001 229.991)">
                                    <path d="M200.148,260.274,227.5,232.92a1.714,1.714,0,0,0-2.424-2.425l-28.574,28.574a1.708,1.708,0,0,0,0,2.424l28.574,28.561a1.722,1.722,0,0,0,1.205.508,1.673,1.673,0,0,0,1.206-.508,1.708,1.708,0,0,0,0-2.424Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+section.icon_secondary_color"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <ng-container *ngIf="section.sections.length > 0 && isOpened && toggleSectionId === section.id">
                        <ng-container *ngFor="let subSection of this.section.sections">
                            <button (click)="buttonClicked(subSection)"
                                    class="shadow-element sub-section color-{{subSection.icon}} custom-section-{{subSection.uid}}"
                                    [ngStyle]="{'background-color' : subSection.background_color}"
                                    [ngClass]="{disabled: subSection.disabled}">
                                <div class="left">
                                    <app-inline-icon-svg [section]="subSection"></app-inline-icon-svg>

                                    <div class="description">
                                        <div class="big" [ngStyle]="{'color': subSection.text_primary_color}" [innerHTML]="subSection.title"></div>
                                        <div class="small"
                                             [ngStyle]="{'color': subSection.text_secondary_color}"
                                             *ngIf="!!subSection.subtitle" [innerHTML]="subSection.subtitle"></div>
                                    </div>
                                </div>
                                <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="32.007" height="60.571" viewBox="0 0 32.007 60.571">
                                    <g transform="translate(228.008 290.562) rotate(180)">
                                        <g transform="translate(196.001 229.991)">
                                            <path d="M200.148,260.274,227.5,232.92a1.714,1.714,0,0,0-2.424-2.425l-28.574,28.574a1.708,1.708,0,0,0,0,2.424l28.574,28.561a1.722,1.722,0,0,0,1.205.508,1.673,1.673,0,0,0,1.206-.508,1.708,1.708,0,0,0,0-2.424Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+subSection.icon_secondary_color"/>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <div class="side-container meeting-pulse" *ngIf="socialUrl">
                    <div class="header">{{'__HOME_INSPIRE_SOCIAL_HEADER__' | translate}}:</div>
                    <div class="body no-padding">
                        <iframe [src]="socialUrl | safeUrl" style="border:none; width: 100%; height: 500px;" allow=“encrypted-media” credentialless>
                        </iframe>
                    </div>
                </div>
            </div>
            <div class="shadow-container grid-middle" *ngIf="userInfo === null">
                <app-skeleton-journey></app-skeleton-journey>
                <app-skeleton-journey></app-skeleton-journey>
                <app-skeleton-journey></app-skeleton-journey>
            </div>
            <div class="side-wrapper grid-left">
                <div class="side-container" *ngIf="isPanelObjectives" (click)="goToReport360()">
                    <div class="header lighter">{{'__HOME_INSPIRE_OBJECTIVES__' | translate}}:</div>
                    <div class="body">
                        <div *ngFor="let item of objectives; let i = index" class="objective">
                            <div class="objective-title">{{item.title | translate}}</div>
                            <div class="objective-content" [innerHTML]="item.content"></div>
                        </div>
                    </div>
                </div>
                <div class="side-container" *ngIf="isPanelLeaderboard && leaderboardData">
                    <div class="header lighter">{{'__HOME_INSPIRE_LEADERBOARD__' | translate}}:</div>
                    <div class="body no-gap" style="padding: .5rem;">
                        <div *ngFor="let item of leaderboardDataTeam; let i = index" class="leaderboard">
                            <div class="leaderboard-position">{{i+1}}</div>
                            <div class="leaderboard-name"><img src="{{item.avatar_url ?? 'assets/img/profile-placeholder.svg'}}"> {{item.full_name}}</div>
                            <div class="leaderboard-total"><strong>{{item.total}}</strong>&nbsp;LPS</div>
                        </div>
                        <div class="leaderboard leaderboard-self" *ngIf="leaderboardDataSelfPosition > 2">
                            <div class="leaderboard-position">{{leaderboardDataSelfPosition + 1}}</div>
                            <div class="leaderboard-name"><img src="{{leaderboardDataSelf.avatar_url ?? 'assets/img/profile-placeholder.svg'}}"> {{leaderboardDataSelf.full_name}}</div>
                            <div class="leaderboard-total"><strong>{{leaderboardDataSelf.total}}</strong>&nbsp;LPS</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="side-wrapper grid-right">
                <div class="side-container link" *ngIf="isPanelPersonalInsight" (click)="goToJourney(323)">
                    <div class="header">{{'__HOME_INSPIRE_PERSONAL_INSIGHTS__' | translate}}</div>
                    <div class="body">
                        <img src="assets/img/inspire/personal-insights.svg" alt="">
<!--                        <div>{{ "__HOME_INSPIRE_VIEW_MORE_INFO_ON_INSIGHTS_REPORT__" | translate }}</div>-->
                    </div>
                </div>
                <div class="side-container link" *ngIf="isPanelReflectionLog" (click)="goToJourney(324)">
                    <div class="header">{{'__HOME_INSPIRE_REFLECTION_LOG__' | translate}}</div>
                    <div class="body">
                        <img src="assets/img/inspire/reflection-log.svg" alt="" style="padding: 1rem 0">
<!--                        <div>{{ "__HOME_INSPIRE_VIEW_MORE_INFO_ON_REFLECTION_LOG__" | translate }}</div>-->
                    </div>
                </div>
                <div class="side-container" *ngIf="!!upcomingEventsList && upcomingEventsList.length > 0">
                    <div class="header lighter">
                        <div>{{'__HOME_INSPIRE_UPCOMING_ACTIVITIES__' | translate}}:</div>
                        <div *ngIf="upcomingEventsList.length" class="number"><span>{{upcomingEventsList.length}}</span></div>
                    </div>
                    <div class="body no-gap" style="padding: .5rem;">
                        <div *ngFor="let item of upcomingEventsList; let i = index" class="upcoming-activity link"
                             (click)="runTask(item)"
                             [ngClass]="{'long-list': upcomingEventsList.length >= 10}">
                            <div class="upcoming-activity-position">{{i+1}}.</div>
                            <div class="upcoming-activity-content">
                                <div class="upcoming-activity-title">{{item.title}}</div>
                                <div class="upcoming-activity-deadline">Deadline: {{item.deadline_at.output.iso | amDateFormat : 'D MMMM' }}</div>
                            </div>
                            <div class="upcoming-activity-status">
                                <app-inline-svg *ngIf="!item.status" [file]="'assets/img/inspire/status-disabled.svg'"></app-inline-svg>
                                <app-inline-svg *ngIf="item.status" [file]="'assets/img/inspire/status-enabled.svg'"></app-inline-svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="side-container copyright">
                    &copy; {{'__HOME_COPYRIGHT_TEXT__' | translate}}
                    {{'__HOME_VERSION__' | translate}}
                    {{authService.appVersion}}{{environment.appVersionSuffix}}
                    <div class='link' (click)="goToLink('https://thisisalchemist.com/privacy-policy-2/')">{{'__HOME_INSPIRE_PRIVACY_POLICY__' | translate}}</div>
                </div>
            </div>
        </div>
    </div>
</ion-content>
